/* eslint-disable import/no-cycle */
import {observer} from 'mobx-react-lite';
import {List} from 'antd';
import {useState} from 'react';
import DocumentListItem from './DocumentListItem';
import styles from './DocumentList.module.scss';
import ShowDocument from '../../document/ShowDocument';

const DocumentList = ({dataSource, title, style}) => {
  const [showingDocument, setShowingDocument] = useState(null);

  return (
    <div style={style} className={styles.documents}>
      {title}
      <List
        className={styles.documentList}
        dataSource={dataSource}
        renderItem={(documentId, index) => (
          <DocumentListItem
            setShowingDocument={setShowingDocument}
            documentId={documentId}
            index={index}
          />
        )}
      />
      {showingDocument && (
        <ShowDocument
          document={showingDocument}
          onCancel={() => setShowingDocument(null)}
        />
      )}
    </div>
  );
};

export default observer(DocumentList);
